<section class="commission screen">
  <header class="commission-bar">
    <h1>COMMISSION &amp; SPIFF</h1>
    <span>ADMIN</span>
  </header>

  <p class="intro">{{ openedLabel }}</p>

  <section class="panel">
    <div class="panel-head">
      <span>COMMISSION SETTINGS</span>
      <span class="sheet-state" *ngIf="!viewingSheet && view === 'open'">OPEN SHEET</span>
      <span class="sheet-state" *ngIf="viewingSheet">PAID SHEET</span>
    </div>
    <div class="settings-grid">
      <label>
        <span>GRO AMOUNT</span>
        <span class="money-field">
          <span>$</span>
          <input
            type="number"
            min="0"
            step="0.01"
            name="groAmount"
            [(ngModel)]="settings.groAmount"
            (blur)="saveSettings()"
            [disabled]="!isAdmin"
          />
        </span>
      </label>
      <label>
        <span>R&amp;G AMOUNT</span>
        <span class="money-field">
          <span>$</span>
          <input
            type="number"
            min="0"
            step="0.01"
            name="rgAmount"
            [(ngModel)]="settings.rgAmount"
            (blur)="saveSettings()"
            [disabled]="!isAdmin"
          />
        </span>
      </label>
      <label>
        <span>READER AMOUNT</span>
        <span class="money-field">
          <span>$</span>
          <input
            type="number"
            min="0"
            step="0.01"
            name="readerAmount"
            [(ngModel)]="settings.readerAmount"
            (blur)="saveSettings()"
            [disabled]="!isAdmin"
          />
        </span>
      </label>
      <label class="aging-rule">
        <span>AGING RULE</span>
        <span class="rule-value">RED status creates SPIFF</span>
      </label>
    </div>
    <p class="settings-note">
      SPIFF uses the GRO amount. Readers use the reader amount. Aging still comes from each vendor’s inventory rule.
    </p>
  </section>

  <div class="filters">
    <label>
      <span>STORE</span>
      <select name="store" [(ngModel)]="storeId" (ngModelChange)="onFilterChange()">
        <option value="all">All Stores</option>
        <option *ngFor="let store of stores" [value]="store._id">{{ store.storeName }}</option>
      </select>
    </label>
    <label>
      <span>REPORT VIEW</span>
      <select name="view" [(ngModel)]="view" (ngModelChange)="onFilterChange()" [disabled]="viewingSheet">
        <option value="open">Current Open Sheet</option>
        <option value="ytd">Year to Date</option>
        <option value="year">Full Year</option>
      </select>
    </label>
    <label>
      <span>YEAR</span>
      <select name="year" [(ngModel)]="year" (ngModelChange)="onFilterChange()">
        <option *ngFor="let option of years" [ngValue]="option">{{ option }}</option>
      </select>
    </label>
    <p class="assignment-note">
      Assignment: the first employee to show the frame receives the full commission.
      Manager may reassign while open; Admin only after paid.
    </p>
    <button
      type="button"
      class="pay-button"
      *ngIf="canOperate && view === 'open' && !viewingSheet"
      (click)="markPaid()"
    >
      MARK ALL AS PAID
    </button>
    <button type="button" class="text-button" *ngIf="viewingSheet" (click)="backToOpen()">
      BACK TO OPEN SHEET
    </button>
  </div>

  <div class="loading" *ngIf="loading">
    <mat-spinner diameter="42"></mat-spinner>
    <span>Loading commission sheet…</span>
  </div>

  <ng-container *ngIf="!loading">
    <p class="empty" *ngIf="!(report?.employees || []).length">
      No qualifying sales in this period.
    </p>

    <section class="panel employee" *ngFor="let employee of report?.employees || []">
      <div class="panel-head">
        <span>EMPLOYEE: {{ employee.initials }}</span>
        <span class="employee-meta">
          {{ employee.salesCount }} {{ employee.salesCount === 1 ? 'SALE' : 'SALES' }} · {{ money(employee.total) }}
        </span>
        <button type="button" class="print-button" (click)="printYtd(employee.id)">PRINT YTD</button>
      </div>
      <div class="table-wrap">
        <table>
          <thead>
            <tr>
              <th>DATE</th>
              <th>MODEL</th>
              <th>COLOR</th>
              <th>EYE SIZE</th>
              <th>PATIENT LAST NAME</th>
              <th>GRO</th>
              <th>R&amp;G</th>
              <th>SPIFF</th>
              <th>READER</th>
              <th>EXAM</th>
              <th>ASSIGNMENT</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let sale of employee.sales">
              <td>{{ shortDate(sale.date) }}</td>
              <td>{{ sale.model }}</td>
              <td>{{ sale.color }}</td>
              <td>{{ sale.eyeSize }}</td>
              <td>{{ sale.patientLastName }}</td>
              <td>{{ sale.category === 'gro' ? '1' : '' }}</td>
              <td>{{ sale.category === 'rg' ? '1' : '' }}</td>
              <td>{{ sale.category === 'spiff' ? '1' : '' }}</td>
              <td>{{ sale.category === 'reader' ? '1' : '' }}</td>
              <td></td>
              <td>
                <button
                  type="button"
                  class="reassign"
                  *ngIf="canReassign; else lockedAssign"
                  (click)="openReassign(sale)"
                >
                  REASSIGN
                </button>
                <ng-template #lockedAssign>LOCKED</ng-template>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="5"></td>
              <td>{{ employee.counts.gro }} / {{ money(employee.dollars.gro, false) }}</td>
              <td>{{ employee.counts.rg }} / {{ money(employee.dollars.rg, false) }}</td>
              <td>{{ employee.counts.spiff }} / {{ money(employee.dollars.spiff, false) }}</td>
              <td>{{ employee.counts.reader }} / {{ money(employee.dollars.reader, false) }}</td>
              <td>{{ employee.counts.exam }} / {{ money(employee.dollars.exam, false) }}</td>
              <td class="total-cell">{{ money(employee.total) }} TOTAL</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </section>

    <section class="panel" *ngIf="(report?.adjustments || []).length">
      <div class="panel-head">
        <span>ADJUSTMENTS</span>
      </div>
      <ul class="adjustments">
        <li *ngFor="let row of report?.adjustments || []">{{ adjustmentText(row) }}</li>
      </ul>
    </section>

    <section class="panel history">
      <div class="panel-head">
        <span>PAID SHEET HISTORY</span>
        <span>ADMIN EDIT ONLY</span>
      </div>
      <div class="history-row" *ngFor="let row of report?.history || []">
        <div>
          <strong>{{ longDate(row.openedAt) }}–{{ longDate(row.closedAt || row.paidAt) }}</strong>
          <span>{{ paidStamp(row) }}</span>
        </div>
        <div class="history-total">
          <strong>{{ money(row.total) }}</strong>
          <span *ngIf="adjusted(row)">Adjusted {{ money(row.adjustedTotal) }}</span>
          <span>Locked</span>
        </div>
        <button type="button" class="view-button" (click)="viewSheet(row)">VIEW SHEET</button>
      </div>
      <p class="empty history-empty" *ngIf="!(report?.history || []).length">No paid sheets yet.</p>
    </section>

    <footer class="page-foot">
      <span>{{ statusLine }}</span>
      <button type="button" class="print-button wide" (click)="printYtd(null)">
        PRINT ALL EMPLOYEES YTD
      </button>
    </footer>
  </ng-container>

  <div class="reassign-backdrop" *ngIf="reassignSale">
    <form class="reassign-card" (ngSubmit)="saveReassign()">
      <h2>Reassign commission</h2>
      <p>{{ reassignSale.model }} · {{ reassignSale.patientLastName }}</p>
      <label>
        <span>EMPLOYEE</span>
        <select name="reassignEmployee" [(ngModel)]="reassignEmployeeId" required>
          <option *ngFor="let user of report?.users || []" [value]="user.id">
            {{ user.initials || user.name }}<ng-container *ngIf="user.name"> — {{ user.name }}</ng-container>
          </option>
        </select>
      </label>
      <label>
        <span>REASON</span>
        <textarea name="reassignReason" [(ngModel)]="reassignReason" required rows="3"></textarea>
      </label>
      <div class="reassign-actions">
        <button type="button" class="text-button" (click)="reassignSale = null">CANCEL</button>
        <button type="submit" class="pay-button">SAVE</button>
      </div>
    </form>
  </div>
</section>

<section class="print-sheet" *ngIf="printReport">
  <h1>COMMISSION &amp; SPIFF</h1>
  <p>Year to date {{ year }}<span *ngIf="printEmployeeId"> · one employee</span></p>
  <section *ngFor="let employee of employeesOf(printReport)">
    <h2>EMPLOYEE: {{ employee.initials }} — {{ employee.salesCount }} sales — {{ money(employee.total) }}</h2>
    <table>
      <thead>
        <tr>
          <th>Date</th>
          <th>Model</th>
          <th>Color</th>
          <th>Eye Size</th>
          <th>Patient</th>
          <th>Category</th>
          <th>Amount</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let sale of employee.sales">
          <td>{{ shortDate(sale.date) }}</td>
          <td>{{ sale.model }}</td>
          <td>{{ sale.color }}</td>
          <td>{{ sale.eyeSize }}</td>
          <td>{{ sale.patientLastName }}</td>
          <td>{{ sale.category | uppercase }}</td>
          <td>{{ money(sale.amount) }}</td>
        </tr>
      </tbody>
    </table>
    <p>
      GRO {{ employee.counts.gro }} / {{ money(employee.dollars.gro) }}
      · R&amp;G {{ employee.counts.rg }} / {{ money(employee.dollars.rg) }}
      · SPIFF {{ employee.counts.spiff }} / {{ money(employee.dollars.spiff) }}
      · Reader {{ employee.counts.reader }} / {{ money(employee.dollars.reader) }}
      · Total {{ money(employee.total) }}
    </p>
  </section>
  <h2>Paid sheets</h2>
  <p *ngFor="let row of printReport.history">
    {{ longDate(row.openedAt) }}–{{ longDate(row.closedAt || row.paidAt) }}
    {{ money(row.total) }}
    <span *ngIf="adjusted(row)">adjusted {{ money(row.adjustedTotal) }}</span>
    · {{ paidStamp(row) }}
  </p>
  <h2 *ngIf="printReport.adjustments?.length">Adjustments</h2>
  <p *ngFor="let row of printReport.adjustments">{{ adjustmentText(row) }}</p>
</section>
